import React from 'react';
import './AddButton.css';

const AddButton = ({ onClick }) => {
  return (
    <button className="add-button" onClick={onClick}>
      <span className="plus-icon">+</span>
      <span>Ajouter</span>
    </button>
  );
};

export default AddButton; 